module.exports = __webpack_public_path__ + "img/last_number.e73b87a7.png";